/* kuvr-flag-alt.js — accessibility/SEO alt text for the raven/scoutcr phone-country
   flag picker. Dev theme 134846447755 only. Reversible: delete this asset + its include line.
   Rule: list-option flags are decorative (country NAME sits beside them) -> alt="".
   The collapsed SELECTED flag has no adjacent text -> it needs the country name. */
(function () {
  function nameFromSrc(img) {
    var m = (img.currentSrc || img.src || '').match(/\/([a-z]{2})\.png/i);
    if (!m) return null;
    try { return new Intl.DisplayNames(['en'], { type: 'region' }).of(m[1].toUpperCase()); }
    catch (e) { return null; }
  }
  function fix(scope) {
    var imgs = (scope || document).querySelectorAll(
      'img[src*="scoutcr"], #raven_country_select_container img'
    );
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.closest('.select-selected')) {          // the sole indicator of chosen country
        var n = nameFromSrc(img);
        img.setAttribute('alt', n || '');
      } else if (!img.hasAttribute('alt') || img.getAttribute('alt') === null) {
        img.setAttribute('alt', '');                   // decorative: name is adjacent text
      }
    }
  }
  if (document.readyState !== 'loading') fix(document);
  document.addEventListener('DOMContentLoaded', function () { fix(document); });
  try {
    var mo = new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) { if (m[i].addedNodes && m[i].addedNodes.length) { fix(document); break; } }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
